module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    attrs: {
      "id": "layout"
    }
  }, [_c('VVisually'), _vm._v(" "), _c('VHeader'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "bread-crumbs"
    }
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('ul', [_vm._m(0), _vm._v(" "), _c('li', [_vm._v(_vm._s(_vm.pageName))])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "holder"
  }, [_c('article', {
    staticClass: "wnd",
    attrs: {
      "id": "message"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.content.fields.content)
    }
  })])])])], 1), _vm._v(" "), _c('VFooter')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Главная")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a8d7848","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CustomPage.vue
// module id = 60
// module chunks = 5